import RouteTemplate from 'ember-route-template';

import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

import AnnouncementSummaries from 'rise-ui/components/announcement-summaries.gjs';
import UiPage from 'rise-ui/components/ui-page.gjs';

export default RouteTemplate(class AboutComponent extends Component {
  <template>
    {{pageTitle "Learn About the Reclamation Information Sharing Environment"}}

    <UiPage @page={{@model.about}} />
    <div>
      <h3 class="c-page-title qa-page-title">Announcements</h3>
      <AnnouncementSummaries
        @announcements={{@model.announcements}}
        @limit="2"
        @more="auto"
      />
    </div>
    {{outlet}}
  </template>
});
